export default "__VITE_ASSET__BV_tEY_8__"